export const UNZER_END_POINTS = {
  makePayment: 'unzer/makePayment',
  createInvoicePayment: 'unzer/createInvoicePayment',
  makeInvoicePayment: 'unzer/makeInvoicePayment',
  getInstallments: 'unzer/getInstallments',
  createInstallmentPayment: 'unzer/createInstallmentPayment',
  makeInstallmentPayment: 'unzer/makeInstallmentPayment',
  makeEPSPayment: 'unzer/makeEpsPayment',
  makeTwintPayment: 'unzer/makeTwintPayment',
  makeGooglePayPayment: 'unzer/makeGooglePayPayment',
  makePFCardPayment: 'unzer/makePFCardPayment',
  makePFFinancePayment: 'unzer/makePFFinancePayment',
  makeApplePayPayment: 'unzer/makeApplePayPayment',
};

export const USECART_END_POINTS = {
  getCart: '/action/cart/getCart',
  getShippingMethods: '/action/cart/getShippingMethods',
  addBonusProductToCart: 'cart/addBonusProductToCart',
  checkout: 'cart/checkout',
  getAccount: '/action/account/getAccount',
  verifyPayment: 'cart/verifyPayment',
  getOrder: 'cart/getOrder',
  selectCashOnDelivery: 'cart/selectCashOnDelivery',
  resetCashOnDelivery: 'cart/resetCashOnDelivery',
  selectVorkassePayment: 'cart/selectVorkassePayment',
  setShippingAddress: 'cart/setShippingAddress',
};
